import React, { useState } from "react";
import PropTypes from "prop-types";
import { useMutation } from "react-apollo";

import { Button, Fieldset, Title, Field, Control } from "rbx";

import { CREATE_BOOKING_CODE_MUTATION } from "../../graphql/BookingCodes/BookingCodes.graphql";
import { ourToast as toast } from "../../utils";

import BookingCodeForm from "./BookingCodeForm";

const DEFAULT_STATE = {
  BookingCode: "",
  Description: "",
  MultipleDays: false,
  Active: true,
  CodeCatgRecIdRef: ""
};
const AddBookingCodeForm = ({ onComplete }) => {
  const [inputs, setInputs] = useState({ ...DEFAULT_STATE });
  const [createBookingCode, { loading }] = useMutation(
    CREATE_BOOKING_CODE_MUTATION,
    {
      refetchQueries: ["ALL_BOOKING_CODES_QUERY"]
    }
  );
  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInputs({ ...inputs, [e.target.name]: value });
  };
  const handleSave = async e => {
    e.preventDefault();
    try {
      await createBookingCode({
        variables: {
          data: {
            ...inputs,
            CodeCatgRecIdRef: inputs.CodeCatgRecIdRef
              ? parseInt(inputs.CodeCatgRecIdRef)
              : null
          }
        }
      });
      onComplete();
      toast.success("Booking Code created successfully.");
    } catch (err) {
      toast.error("Error creating Booking Code.");
    }
  };
  return (
    <form
      className="add-booking-code-form"
      id="add-booking-code-form"
      onSubmit={handleSave}
    >
      <Title>Add Booking Code</Title>
      <Fieldset disabled={loading}>
        <BookingCodeForm inputs={inputs} onChange={handleChange} />
        <hr />
        <Field kind="group">
          <Control>
            <Button color="success" form="add-booking-code-form" type="submit">
              Submit
            </Button>
          </Control>
          <Control>
            <Button type="button" onClick={onComplete}>
              Cancel
            </Button>
          </Control>
        </Field>
      </Fieldset>
    </form>
  );
};

AddBookingCodeForm.propTypes = {
  onComplete: PropTypes.func
};

export default AddBookingCodeForm;
